import Auth from "./auth";
import { getHvaSessionId } from "./tracking";

const withSessionHeader = <T extends Record<string, string>>(headers: T): T & { "X-Session-Id"?: string } => {
  const sessionId = getHvaSessionId();
  if (sessionId === null) {
    return headers;
  }
  return { ...headers, "X-Session-Id": sessionId };
};

export const getGetHeaders = async (
  contentType: string = "application/json",
  { minTokenSecondsLeft }: { minTokenSecondsLeft?: number } = {}
) => {
  return withSessionHeader({
    Accept: contentType,
    Authorization: await Auth.getBearerToken(minTokenSecondsLeft)
  });
};

export const getPostHeaders = async (minTokenSecondsLeft?: number) => {
  // getGetHeaders() already applies withSessionHeader; don't re-wrap here or
  // we'd call datadogRum.getInternalContext() twice per POST.
  return {
    ...(await getGetHeaders(undefined, { minTokenSecondsLeft })),
    "Content-Type": "application/json"
  };
};

/**
 * Get headers for FormData POST requests.
 * Does NOT include Content-Type - browser will set it automatically with multipart boundary.
 */
export const getFormDataHeaders = async () => {
  return withSessionHeader({
    Accept: "application/json",
    Authorization: await Auth.getBearerToken()
  });
};
